import React from "react";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import HeaderImage2 from "../../images/banner-side -image.png";
import { Container } from "react-bootstrap";
const ShippingPolicy = () => {
  return (
    <>
      <SectionHeader
        title="Shipping Policy"
        image={HeaderImage}
        image2={HeaderImage2}
        title2="Shipping Policy for BOLT-CORP"
        content="At BOLT-CORP, we are committed to providing a seamless shopping
              experience. Here is everything you need to know about our shipping
              process:"
      ></SectionHeader>
      <div className="pt-5">
        <Container>
          <div className="pt-5 pb-4">
            <p>
              <strong>Processing Time: </strong>
              Orders are typically processed within 1–3 business days from
              purchase, excluding weekends and holidays. Once your order is
              processed, you will receive a confirmation email with tracking
              details
            </p>
            <p>
              <strong>Shipping Methods and Delivery Times: </strong>
              We offer a range of shipping options to suit your needs:
              <ul>
                <li>
                  <strong>Standard Shipping: </strong> 5-7 business days
                </li>
                <li>
                  <strong>Expedited Shipping: </strong> 2-4 business days
                </li>
              </ul>
            </p>
            <p>
              Delivery times may vary depending on the destination and the order
              size. We will provide estimated delivery dates upon checkout.
            </p>
            <p>
              <strong>Shipping Charges: </strong>
              Shipping costs are calculated at checkout based on the shipping
              method selected, the size and weight of your order, and the
              delivery address. We offer free standard shipping on orders over a
              certain amount. Please check our website or contact us for more
              details on current promotions.
            </p>
            <p>
              <strong>International Shipping: </strong>
              We currently ship to the following countries: [list countries].
              International shipping times and costs will vary depending on the
              destination. Please note that international orders may be subject
              to customs duties, taxes, and import fees, which are the
              customer's responsibility.
            </p>
            <p>
              <strong>Order Tracking: </strong>
              Once your order has been shipped, you will receive an email with a
              tracking number to monitor your shipment. You can track your
              package via our carrier's website or directly through the link
              provided in your confirmation email.
            </p>
            <p>
              <strong>Lost or Damaged Items: </strong>
              If your item is lost or damaged during transit, please get in
              touch with our customer service team at [contact information]
              immediately. We will assist you in resolving the issue and provide
              a replacement or refund where applicable.
            </p>
            <p>
              <strong>Incorrect Address: </strong>
              Please ensure your shipping address is accurate before completing
              your order. BOLT-CORP is not responsible for shipping delays or
              delivery issues caused by incorrect or incomplete address
              information.
            </p>
            <p>
              <strong>Shipping Restrictions: </strong>
              Certain products may be restricted to specific locations due to
              size, weight, or legal regulations. We will notify you if any
              items in your order cannot be shipped to your selected address.
            </p>
            <p>
              <strong>Changes to the Shipping Policy: </strong>
              BOLT-CORP reserves the right to update or modify this shipping
              policy anytime. Any changes will be posted on this page with the
              updated date. <br /><br /> Please contact our customer service team if you have
              any questions or need assistance. We're here to help!
            </p>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ShippingPolicy;
